// Light / dark mode toggle (the .theme-toggle buttons).
// The inline script in each page's <head> already set html[data-theme] before
// the first paint; this only handles the buttons and system changes.
// The visitor's choice is remembered; without one, the system setting wins.
const KEY = "theme";

export default function initTheme() {
  const root = document.documentElement;
  const system = window.matchMedia("(prefers-color-scheme: dark)");
  const buttons = [...document.querySelectorAll(".theme-toggle")];

  function saved() {
    try {
      const t = localStorage.getItem(KEY);
      return t === "dark" || t === "light" ? t : null;
    } catch {
      return null;
    }
  }

  function apply(theme) {
    root.dataset.theme = theme;
    const next = theme === "dark" ? "light" : "dark";
    for (const b of buttons) {
      b.setAttribute("aria-label", `Switch to ${next} mode`);
      b.title = `Switch to ${next} mode`;
      b.querySelector("i").className = `fa fa-${theme === "dark" ? "sun-o" : "moon-o"}`;
    }
  }

  for (const b of buttons) {
    b.addEventListener("click", () => {
      const theme = root.dataset.theme === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(KEY, theme);
      } catch {}
      apply(theme);
    });
  }
  system.addEventListener("change", (e) => {
    if (!saved()) apply(e.matches ? "dark" : "light");
  });
  apply(root.dataset.theme === "dark" ? "dark" : "light");
}
